
import { useSelector, useDispatch } from 'react-redux'
import { UserInMeeting } from './UserInMeeting';
import { NotarUserInMeeting } from './NotarUserInMeeting';
import { DocInMeeting } from './DocInMeeting';
import { Logout,   } from 'tabler-icons-react';
import { Text, Title, Grid, Group, Avatar,Indicator,createStyles, ActionIcon, Modal, Button, Tooltip } from '@mantine/core';
import { setdisplaywidth } from '../slice/mainslice';
import { LayoutColumns, LayoutRows, ArrowBarLeft } from 'tabler-icons-react';
import { useState } from 'react';
import intl from 'react-intl-universal';
import ClientChangeLanguage from '../helperforall/ClientChangeLanguage';


const useStyles = createStyles((theme) => ({
    padtop10: {
      paddingTop: `10px`,
    },
  }));


/**
 * Generates the User Tools View in small size, including handling user status, logout functionality, and layout options.
 *
 * @meuser: {Object} - state.user.meuser - The current user.
 * @meetinguser: {Object} - state.user.meetinguser - The current meeting user.
 * @meetinginfo: {Object} - state.user.meetinginfo - The current meeting information.
 * @showdoc: {Object} - state.user.showmeetingdocs - Objekt der Dokumente im Meeting.
 * @showsigndoc: {Object} - state.user.showsignmeetingdocs - Objekt des Dokumentes to Sign.
 * 
 * @return {JSX.Element} the User Tools View component in small size
 */
const UserToolsViewSmall = (props: any) => {
    const { classes } = useStyles();
    const dispatch = useDispatch()
    const meuser = useSelector((state: any) => state.user.meuser)
    const meetinguser = useSelector((state: any) => state.user.meetinguser)
    const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
    const showdoc = useSelector((state: any) => state.user.showmeetingdocs)
    const showsigndoc = useSelector((state: any) => state.user.showsignmeetingdocs)
    const [logoutopened, setLogoutopened] = useState(false);

    let a = meuser.lastName.substring(0,1)
    let b = meuser.firstName.substring(0,1)
    let initialen = b + a

    const handleLogout = () => {
      setLogoutopened(true);
    };

    const handleLogoutclose = () => {
      setLogoutopened(false);
    };
  
    const handleLogoutYesClick = () => {
      sentlogoutcommand();
      handleLogoutclose();
    };
  
    const handleLogoutNoClick = () => {
      handleLogoutclose();
    };   

    const sentlogoutcommand = () => {
      const handlelogoutpayload = {
        drnId: meetinginfo.drnId,
        command: "closedoc"   
      }; 
      dispatch({ type: 'SIGNALR_SENDCLOSEMEETING', payload: handlelogoutpayload });
    }

      // Status Abzeige Online UserMe ()
    const meuserstatus = meetinguser.filter((obj: { id: any; }) => {
    return obj.id === meuser.id
    });
  
  let userstatuscolor = "red";
  if(meuserstatus[0].meetingParticipantStatus === "LeftMeeting") {
    userstatuscolor = "red";
  }
  if(meuserstatus[0].meetingParticipantStatus === "InMeeting") {
    userstatuscolor = "green";
  }
   
  return (
    <>
     <Grid >
      <Grid.Col xs={12} >
        <Group position="right" className={classes.padtop10}>
          <Tooltip label={intl.get('TOOLSVIEW_FULL')} multiline={true}><span><ArrowBarLeft size={30}  onClick={() => props.setOpentool(true)}/></span></Tooltip>     
          <Tooltip label={intl.get('TOOLSVIEW_LOGOUT')} multiline={true}><span><Logout size={30} strokeWidth={1} color={'black'} onClick={handleLogout} /></span></Tooltip>
        </Group>
      </Grid.Col>
      <Grid.Col xs={12} >
        <Group position="right" >
          <ClientChangeLanguage />
        </Group> 
        <Group position="right" className={classes.padtop10}>
          <Indicator inline size={12} offset={4} position="bottom-end" color={userstatuscolor} withBorder >
              <Avatar  variant="filled" radius="xl" size="md">{initialen}</Avatar>
          </Indicator>
        </Group> 
      </Grid.Col>  
    </Grid>
    <NotarUserInMeeting view={"small"}/>
    <UserInMeeting view={"small"}/>
    <DocInMeeting view={"small"}/>

    {showdoc.resourceId !== undefined  &&
                <>
                <hr />
                <Title order={3}>{intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                <Group position="left">
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                        <LayoutRows style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                        <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                </Group>
                </>
    }
    {showsigndoc.resourceId !== undefined  &&
                <>
                <hr />
                <Title order={3}>{intl.get('TOOLSVIEW_LAYOUT_HEAD')}</Title>
                <Group position="left">
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(1))}>
                        <LayoutRows style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                  <ActionIcon variant="outline" size="xl" aria-label="Settings" onClick={() => dispatch(setdisplaywidth(2))}>
                        <LayoutColumns style={{ width: '70%', height: '70%' }}   />
                  </ActionIcon>
                </Group>
                </>
    }

<Modal
        title={intl.get('TOOLSVIEW_MODAL_ENDMEETING')}
        opened={logoutopened}
        onClose={handleLogoutclose}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        >
          <Text>{intl.get('TOOLSVIEW_MODAL_ENDMEETING_TEXT')} </Text>
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleLogoutYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="red" variant="light" onClick={handleLogoutNoClick}>{intl.get('DIALOG_BUTTON_NO_CLOSE')}</Button>
            </Grid.Col>
          </Grid>
      </Modal> 
   

    </>
  );
}


export default UserToolsViewSmall ;